export default "__VITE_ASSET__8HgPAV17__"